import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Tab } from 'app/models/tab';

@Component({
  selector: 'app-tab-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tab-list.component.html',
  styleUrl: './tab-list.component.scss',
})
export class TabListComponent {
  @Input() size: 'medium' | 'full' | string = '';
  @Input() tabs: Tab[] = [];
  @Input() currentTab!: Tab;

  @Output() currentTabEmitter: EventEmitter<number> =
    new EventEmitter<number>();

  // Zoom related properties for breakpoint observer
  isZoomed: boolean = false;

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe(['(max-width: 900px)'])
      .subscribe((result) => {
        // result matches returns true if the width is <= 900px
        this.isZoomed = result.matches;
      });
  }

  toggleTab(tab: Tab) {
    this.currentTab = tab;
    this.currentTabEmitter.emit(this.currentTab.tabNumberOrder);
  }
}
